import { render, staticRenderFns } from "./addFreightTmplate.vue?vue&type=template&id=01108886&scoped=true"
import script from "./addFreightTmplate.vue?vue&type=script&lang=js"
export * from "./addFreightTmplate.vue?vue&type=script&lang=js"
import style0 from "./addFreightTmplate.vue?vue&type=style&index=0&id=01108886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01108886",
  null
  
)

export default component.exports